// extracted by mini-css-extract-plugin
module.exports = {"root":"NearbyListingsSection_root__2WSDn"};